import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Button, Select } from '@outdoor-voices/ui';
import { useState } from 'react';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { DT, POST_HEADERS } from '../../../config/constants';
import { KUSTOMER_PUBLIC_API_URL } from './constants';
import css from './Form.module.scss';
import Suggestions from './Suggestions';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Form = function Form(_ref) {
  var _window$OV, _window$OV$CUSTOMER;

  var categories = _ref.categories,
      copy = _ref.copy,
      title = _ref.title;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      submitting = _useState4[0],
      setSubmitting = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      submitted = _useState6[0],
      setSubmitted = _useState6[1];

  var _useState7 = useState({
    name: '',
    email: ((_window$OV = window.OV) === null || _window$OV === void 0 ? void 0 : (_window$OV$CUSTOMER = _window$OV.CUSTOMER) === null || _window$OV$CUSTOMER === void 0 ? void 0 : _window$OV$CUSTOMER.email) || '',
    helpWith: '',
    orderNumber: '',
    subject: '',
    message: ''
  }),
      _useState8 = _slicedToArray(_useState7, 2),
      state = _useState8[0],
      setState = _useState8[1];

  var onChange = function onChange(event) {
    var _event$target = event.target,
        name = _event$target.name,
        value = _event$target.value;

    var newState = _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, name, value));

    setState(newState);
  }; // Create a message in Kustomer


  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      var message, request;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();
              setSubmitting(true);
              setError(false);
              message = "\nOrder Number: ".concat(state.orderNumber, "\n\nWhat can we help you with?: ").concat(state.helpWith, "\n\nSubject: ").concat(state.subject, "\n\nMessage: ").concat(state.message, "\n");
              _context.next = 6;
              return fetch(KUSTOMER_PUBLIC_API_URL, _objectSpread(_objectSpread({}, POST_HEADERS), {}, {
                body: JSON.stringify({
                  email: state.email,
                  name: state.name,
                  message: message,
                  subject: "Submission from Help Center: ".concat(state.subject)
                })
              }));

            case 6:
              request = _context.sent;
              _context.prev = 7;
              _context.next = 10;
              return request.json();

            case 10:
              setSubmitted(true);
              _context.next = 18;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](7);
              console.error(_context.t0);
              setSubmitting(false);
              setError(_context.t0.message);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[7, 13]]);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [submitted && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: css.title,
        children: "Slam Dunk"
      }), /*#__PURE__*/_jsx("p", {
        className: css.copy,
        children: "We\u2019ve received your message, and we\u2019ll get back to you ASAP."
      })]
    }), !submitted && /*#__PURE__*/_jsxs("form", {
      onSubmit: onSubmit,
      children: [title && /*#__PURE__*/_jsx("div", {
        className: css.title,
        children: title
      }), copy && /*#__PURE__*/_jsx("p", {
        className: css.copy,
        children: copy
      }), /*#__PURE__*/_jsxs("fieldset", {
        className: css.fieldset,
        children: [/*#__PURE__*/_jsx("legend", {
          className: "ada-hidden",
          children: "Submit a help request to Customer Service"
        }), /*#__PURE__*/_jsx("div", {
          className: css.required,
          children: "*Required information"
        }), /*#__PURE__*/_jsxs("div", {
          className: css.fieldGroup,
          children: [/*#__PURE__*/_jsxs("label", {
            className: css.field,
            htmlFor: "contact-name",
            children: [/*#__PURE__*/_jsx("div", {
              className: css.label,
              children: "Name*"
            }), /*#__PURE__*/_jsx("input", {
              autoComplete: "name",
              className: css.input,
              id: "contact-name",
              name: "name",
              onChange: onChange,
              required: true,
              value: state.name
            })]
          }), /*#__PURE__*/_jsxs("label", {
            className: css.field,
            htmlFor: "contact-email",
            children: [/*#__PURE__*/_jsx("div", {
              className: css.label,
              children: "Email*"
            }), /*#__PURE__*/_jsx("input", {
              className: css.input,
              id: "contact-email",
              name: "email",
              value: state.email,
              onChange: onChange,
              required: true,
              type: "email"
            })]
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: css.fieldGroup,
          children: /*#__PURE__*/_jsxs("label", {
            className: css.field,
            htmlFor: "contact-order-number",
            children: [/*#__PURE__*/_jsx("div", {
              className: css.label,
              children: "Order Number"
            }), /*#__PURE__*/_jsx("div", {
              className: css.hint,
              children: "Don\u2019t have an order number? No sweat."
            }), /*#__PURE__*/_jsx("input", {
              className: css.input,
              id: "contact-order-number",
              name: "orderNumber",
              onChange: onChange,
              value: state.orderNumber
            })]
          })
        }), /*#__PURE__*/_jsx("div", {
          className: css.fieldGroup,
          children: /*#__PURE__*/_jsx("div", {
            className: css.field,
            children: /*#__PURE__*/_jsx(Select, {
              className: css.input,
              id: "contact-help-with",
              label: "What can we help you with?*",
              placeholder: "Select a topic",
              name: "helpWith",
              onChange: onChange,
              options: categories.map(function (_ref3) {
                var title = _ref3.title;
                return {
                  label: title,
                  value: title
                };
              }),
              required: true,
              value: state.helpWith
            })
          })
        }), /*#__PURE__*/_jsx("div", {
          className: css.fieldGroup,
          children: /*#__PURE__*/_jsx("div", {
            className: css.field,
            children: /*#__PURE__*/_jsx(Suggestions, {
              hint: 'Let&rsquo;s get more specific.',
              id: "subject",
              label: "Subject*",
              onChange: onChange,
              openInNewTab: true,
              value: state.subject
            })
          })
        }), /*#__PURE__*/_jsx("div", {
          className: css.fieldGroup,
          children: /*#__PURE__*/_jsxs("label", {
            className: cc([css.field, css.wide]),
            htmlFor: "contact-message",
            children: [/*#__PURE__*/_jsx("div", {
              className: css.label,
              children: "Tell us more*"
            }), /*#__PURE__*/_jsx("textarea", {
              className: css.textarea,
              id: "contact-message",
              name: "message",
              value: state.message,
              onChange: onChange,
              required: true
            })]
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: css.actions,
        children: [error && /*#__PURE__*/_jsx("div", {
          className: css.error,
          children: error
        }), /*#__PURE__*/_jsx(Button, {
          "aria-label": "Send a message to Outdoor Voices customer support",
          disabled: submitting,
          big: true,
          type: "submit",
          children: submitting ? DT : 'Submit'
        })]
      })]
    })]
  });
};

Form.propTypes = {
  copy: PropTypes.string,
  categories: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string
  })),
  title: PropTypes.string
};
export default Form;